module.exports = __webpack_public_path__ + "static/img/nose_05.ec8c60d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/noses/thumbnail/nose_05.png
// module id = HKuP
// module chunks = 0